import React from "react";

/* Compact status badge — replaces legacy uiComponents/StatusBox. */

export function StatusBox({
  children,
  background,
  colour,
  width,
  addLeftSpacing = false,
  addTopSpacing = false,
  style,
  ...rest
}) {
  return (
    <div
      style={{
        background: background || "var(--slate)",
        color: colour || "var(--white)",
        width,
        marginLeft: addLeftSpacing ? 10 : "auto",
        marginRight: "auto",
        marginTop: addTopSpacing ? 5 : "auto",
        fontSize: 14,
        fontWeight: 600,
        padding: "5px 10px",
        borderRadius: 4,
        position: "relative",
        fontFamily: "var(--font-sans)",
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
}

export default StatusBox;
